import * as React from 'react'
import dayjs from 'dayjs'
import { DatePicker } from 'antd'

import { useGateway } from './hooks'
import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormCheck,
  CFormInput,
  CFormSelect,
  CMultiSelect,
  CRow,
} from '@coreui/react-pro'
import {
  detachExchanger,
  setDeleteAccess,
  setDeleteOperation,
  setDeleteOperationLimit,
  setDeleteWeight,
  setGateway,
  submitEditGateway,
  submitSaveAccess,
  submitSaveOperation,
  submitSaveOperationLimit,
  submitSaveWeight,
  $withdrawalGroups,
  submitSaveCommission,
} from './model'
import {
  AutoComplete,
  Button,
  Card,
  Divider,
  Image,
  message,
  Popconfirm,
  Typography,
  Upload,
  UploadProps,
} from 'antd'
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  CloseSquareOutlined,
  DeleteOutlined,
  PlusSquareOutlined,
  UploadOutlined,
} from '@ant-design/icons'
import { processingProvider } from '../../../libs/processingProvider'
import { useUnit } from 'effector-react'
import { useCallback, useState } from 'react'
import { debounce } from 'lodash'
import {
  $exchangerOptions,
  exchangerDataMounted,
  setGatewayExchanger,
} from '../create/model'
import { path } from '../../../libs'
import { toPath } from '../../../features/router'
import { CommissionFormComponent } from './atoms/commissionForm/component'
import { getNoticeText } from './atoms/const'
import { deleteGatewayEvent } from '../list/model'
import { Guard } from '../../../features/session/guard'
import { $countriesList } from '../../../features/dictionaries/model'
import { transformCountriesToOptions } from '../../../libs/formatCountries'
import { Gateway } from 'src/pages/gateway/edit/types'
import { AddNoticeModal, RemoveNoticeModal } from 'src/pages/gateway/edit/atoms'
import { GUARD_RULES } from 'src/features/session/constants'
import { METHOD_KIND } from 'src/pages/gateway/const'

export const GatewayEditDetail = () => {
  const [gatewayAddNotice, setGatewayAddNotice] = useState<Gateway | null>(null)
  const [gatewayRemoveNotice, setGatewayRemoveNotice] =
    useState<Gateway | null>(null)
  const { gateway, loading, error, gatewayExchanger } = useGateway()
  const exchangerOptions = useUnit($exchangerOptions)
  const withdrawalGroupsOptions = useUnit($withdrawalGroups)
  const countriesList = useUnit($countriesList)
  const wdOptions = withdrawalGroupsOptions.map((item) => {
    return {
      label: item.text,
      value: item.value,
    }
  })
  const [ownerName, setOwnerName] = useState('')

  const debounceLoadData = useCallback(debounce(exchangerDataMounted, 1000), [])
  const handleGetClient = (id: string) => {
    if (id.length >= 1) {
      debounceLoadData({ id })
    }
  }
  const props: UploadProps = {
    name: 'file',
    maxCount: 1,
    beforeUpload: (file) => {
      // @ts-ignore
      setGateway({ ...gateway, file: file })
      return false
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        message
          .success(`${info.file.name} file uploaded successfully`)
          .then((r) => console.log(r))
      } else if (info.file.status === 'error') {
        message
          .error(`${info.file.name} file upload failed.`)
          .then((r) => console.log(r))
      }
    },
  }
  function submitSaveQueue<F extends Function, A extends Array<any>>(
    objects: A,
    func: F,
  ) {
    objects.forEach((value) => {
      func(value)
    })
  }

  const handleChange = (event: {
    target: { name: any; type: string; checked?: any; value: any }
  }) => {
    const value =
      event.target.type === 'checkbox'
        ? event.target.checked
        : event.target.value
    setGateway({
      ...gateway,
      [event.target.name]: value,
    })
  }
  const handleExchangerChange = (event: {
    target: { name: any; type: string; checked?: any; value: any }
  }) => {
    const value =
      event.target.type === 'checkbox'
        ? event.target.checked
        : event.target.value

    setGatewayExchanger({
      ...gatewayExchanger,
      [event.target.name]: value,
    })
  }
  const handleAccessChange = (index: number, objectKey: string, value: any) => {
    const currentAccess = [...gateway.gatewayAccess]
    currentAccess[index] = {
      ...gateway.gatewayAccess[index],
      [objectKey]: value,
    }
    setGateway({ ...gateway, gatewayAccess: currentAccess })
  }
  const handleCommissionChange = (
    index: number,
    objectKey: string,
    value: any,
  ) => {
    const currentCommission = [...gateway.gatewayCommissions]
    currentCommission[index] = {
      ...gateway.gatewayCommissions[index],
      [objectKey]: value,
    }

    if (
      objectKey === 'operationType' ||
      objectKey === 'payer' ||
      objectKey === 'acquirer'
    ) {
      const { operationType, payer, acquirer } = currentCommission[index]

      const isDuplicate = currentCommission.some(
        (commission, i) =>
          i !== index &&
          commission.operationType === operationType &&
          commission.acquirer === acquirer &&
          commission.payer === payer,
      )

      if (isDuplicate) {
        alert('Такая комбинация уже существует!')
        return
      }
    }

    setGateway({ ...gateway, gatewayCommissions: currentCommission })
  }
  const handleOperationChange = (
    index: number,
    objectKey: string,
    value: any,
  ) => {
    const currentOperations = [...gateway.gatewayOperations]
    currentOperations[index] = {
      ...gateway.gatewayOperations[index],
      [objectKey]: value,
    }
    setGateway({ ...gateway, gatewayOperations: currentOperations })
  }
  const handleOperationLimitChange = (
    currentOperation: number,
    index: number,
    objectKey: string,
    value: any,
  ) => {
    const currentOperations = [...gateway.gatewayOperations]
    currentOperations[currentOperation].gatewayOperationLimits[index] = {
      ...gateway.gatewayOperations[currentOperation].gatewayOperationLimits[
        index
      ],
      [objectKey]: value,
    }
    setGateway({ ...gateway, gatewayOperations: currentOperations })
  }
  const handleWeightChange = (index: number, objectKey: string, value: any) => {
    const currentWeight = [...gateway.gatewayWeight]
    currentWeight[index] = {
      ...gateway.gatewayWeight[index],
      [objectKey]: value,
    }
    setGateway({ ...gateway, gatewayWeight: currentWeight })
  }
  const handleChangeAutoComplete = (value: string) => {
    setOwnerName(value)
  }

  const handleInput = (e: any) => {
    handleOnSelect(e.value)
  }

  const handleOnSelect = (value: string) => {
    const ownerId = exchangerOptions.find((item) => item.value === value)?.id
    if (ownerId) {
      setGatewayExchanger({
        ...gatewayExchanger,
        ownerId,
      })
      setGateway({ ...gateway, exchangerId: ownerId })
    }
  }

  return (
    <div>
      {error.message.length > 0 && (
        <CAlert color="danger">Error code: {error.message}</CAlert>
      )}
      <CCard className="mb-4">
        <CCardHeader className="d-sm-flex justify-content-between align-items-center">
          <strong>Gateway info</strong>
        </CCardHeader>
        <CCardBody>
          <CRow className="justify-content-between align-items-center">
            <CCol>
              <strong>ID:</strong> {gateway.gatewayId}
            </CCol>
            <CCol>
              <strong>Title:</strong> {gateway.name}
            </CCol>
            <CCol>
              <strong>Hash:</strong> {gateway.praxisGatewayHash}
            </CCol>
            <CCol>
              <strong>Logo:</strong>{' '}
              <Image src={gateway.logo} alt={gateway.logo} width={100} />
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
      <CCard className="mb-4">
        <CCardHeader className="d-sm-flex justify-content-between align-items-center">
          <strong>Edit gateway {gateway.gatewayId}</strong>
        </CCardHeader>
        <CCardBody>
          <Divider />
          <CRow>
            <CCol>
              <CRow className="mb-3 align-items-center">
                <CCol className="d-sm-flex justify-content-start align-items-center gap-3">
                  <strong>Support:</strong>
                  <div className="d-sm-flex justify-content-start align-items-center gap-4">
                    <div className="d-sm-flex align-items-center gap-1">
                      isDepositSupported:
                      {gateway.praxisGateway?.isDepositSupported ? (
                        <CheckCircleOutlined className={'text-success'} />
                      ) : (
                        <CloseSquareOutlined className={'text-danger'} />
                      )}
                    </div>
                    <div className="d-sm-flex align-items-center gap-1">
                      isRefundSupported:
                      {gateway.praxisGateway?.isRefundSupported ? (
                        <CheckCircleOutlined className={'text-success'} />
                      ) : (
                        <CloseSquareOutlined className={'text-danger'} />
                      )}
                    </div>
                    <div className="d-sm-flex align-items-center gap-1">
                      isPayoutSupported:
                      {gateway.praxisGateway?.isPayoutSupported ? (
                        <CheckCircleOutlined className={'text-success'} />
                      ) : (
                        <CloseSquareOutlined className={'text-danger'} />
                      )}
                    </div>
                  </div>
                </CCol>
              </CRow>
              <Divider />
              <CRow className="mb-3 align-items-center">
                <CCol>
                  <CFormSelect
                    key="withdrawalGroupId"
                    id="withdrawalGroupId"
                    label="Withdrawal Group"
                    value={gateway.withdrawalGroupId}
                    className="mb-2"
                    options={[
                      //@ts-ignore
                      'Select group',
                      ...wdOptions.map((item) => {
                        return {
                          value: item.value.toString(),
                          label: item.label,
                        }
                      }),
                    ]}
                    onChange={(event) => {
                      handleChange({
                        target: {
                          value: event.currentTarget.value,
                          name: 'withdrawalGroupId',
                          type: '',
                        },
                      })
                    }}
                  ></CFormSelect>
                  <CFormInput
                    id="psCode"
                    name="psCode"
                    value={gateway.psCode}
                    label="PS Code"
                    onChange={handleChange}
                  />
                  <div className="d-sm-flex justify-content-between align-items-center">
                    <Upload {...props}>
                      <Button icon={<UploadOutlined />}>Click to Upload</Button>
                    </Upload>
                    <Image src={gateway.logo} width={300} />
                  </div>
                  <br />
                  <CFormInput
                    id="name"
                    name="name"
                    value={gateway.name}
                    label="name"
                    onChange={handleChange}
                  />
                  <CFormInput
                    id="internalName"
                    name="internalName"
                    value={gateway.internalName}
                    label="internalName"
                    onChange={handleChange}
                  />

                  <CMultiSelect
                    key="paymentMethodType"
                    id="paymentMethodType"
                    label="paymentMethodType"
                    multiple={false}
                    options={[
                      {
                        text: 'credit_card',
                        value: 'credit_card',
                        selected: gateway.paymentMethodType == 'credit_card',
                      },
                      {
                        text: 'online_bank',
                        value: 'online_bank',
                        selected: gateway.paymentMethodType == 'online_bank',
                      },
                      {
                        text: 'e_wallet',
                        value: 'e_wallet',
                        selected: gateway.paymentMethodType == 'e_wallet',
                      },
                      {
                        text: 'crypto',
                        value: 'crypto',
                        selected: gateway.paymentMethodType == 'crypto',
                      },
                      {
                        text: 'exchanger',
                        value: 'exchanger',
                        selected: gateway.paymentMethodType == 'exchanger',
                      },
                    ]}
                    onChange={(event) => {
                      let select: (string | number)[] = []
                      event.forEach((item) => select.push(item.value))
                      handleChange({
                        target: {
                          value: select.pop(),
                          checked: false,
                          name: 'paymentMethodType',
                          type: '',
                        },
                      })
                    }}
                  ></CMultiSelect>
                  {gateway.paymentMethodType === 'exchanger' && (
                    <>
                      <CRow className="mb-3 mt-3 d-flex align-items-end">
                        <CCol sm={2} className="d-flex flex-column">
                          Exchanger link
                          <a
                            href={path.exchangers.edit(
                              String(gateway.exchangerId),
                            )}
                            target="_blank"
                          >
                            {gateway.exchangerId}
                          </a>
                        </CCol>
                        <CCol sm={3} className="d-flex flex-column">
                          <Typography.Text>Exchanger owner</Typography.Text>
                          <AutoComplete
                            onChange={(value, option) =>
                              handleChangeAutoComplete(value)
                            }
                            onSelect={handleOnSelect}
                            onInputKeyDown={handleInput}
                            value={ownerName}
                            options={exchangerOptions}
                            style={{ width: 300 }}
                            onSearch={(text) => handleGetClient(text)}
                          />
                        </CCol>
                        <CCol sm={1} className="d-flex flex-column">
                          <CButton
                            color="warning"
                            className="ms-2"
                            disabled={loading}
                            onClick={() => {
                              if (
                                window.confirm(
                                  `Are you sure you wish detach exchanger ${gateway.exchangerId} from gateway ${gateway.gatewayId}?. Ensure what you disable access to this gateway`,
                                )
                              )
                                detachExchanger(gateway)
                            }}
                          >
                            Detach
                          </CButton>
                        </CCol>
                      </CRow>
                    </>
                  )}
                  {gateway.paymentMethodType !== 'exchanger' && (
                    <>
                      <CMultiSelect
                        key="processingProvider"
                        id="processingProvider"
                        label="processingProvider"
                        multiple={false}
                        options={processingProvider.map((item) => {
                          if (gateway.processingProvider == item.value) {
                            return { ...item, selected: true }
                          } else {
                            return { ...item, selected: false }
                          }
                        })}
                        onChange={(event) => {
                          let select: (string | number)[] = []
                          event.forEach((item) => select.push(item.value))
                          handleChange({
                            target: {
                              value: select.pop(),
                              checked: false,
                              name: 'processingProvider',
                              type: '',
                            },
                          })
                        }}
                      ></CMultiSelect>
                      <CFormInput
                        id="praxisGatewayHash"
                        name="praxisGatewayHash"
                        value={gateway.praxisGatewayHash}
                        label="praxisGatewayHash"
                        onChange={handleChange}
                      />
                    </>
                  )}
                  <CMultiSelect
                    key="technicalMethodKind"
                    id="technicalMethodKind"
                    label="Technical Payment Method Type"
                    multiple={false}
                    options={[
                      {
                        text: 'Unknown',
                        value: METHOD_KIND.MK_UNKNOWN,
                        // странное поведение BE - передаем MK_UNKNOWN возвращает null
                        selected:
                          gateway.technicalMethodKind ===
                            METHOD_KIND.MK_UNKNOWN ||
                          gateway.technicalMethodKind === null,
                      },
                      {
                        text: 'Mobile Money',
                        value: METHOD_KIND.MK_MOBILE_MONEY,
                        selected:
                          gateway.technicalMethodKind ===
                          METHOD_KIND.MK_MOBILE_MONEY,
                      },
                      {
                        text: 'Bank Transfer',
                        value: METHOD_KIND.MK_BANK_TRANSFER,
                        selected:
                          gateway.technicalMethodKind ===
                          METHOD_KIND.MK_BANK_TRANSFER,
                      },
                      {
                        text: 'Local method',
                        value: METHOD_KIND.MK_LOCAL_METHOD,
                        selected:
                          gateway.technicalMethodKind ===
                          METHOD_KIND.MK_LOCAL_METHOD,
                      },
                      {
                        text: 'Crypto',
                        value: METHOD_KIND.MK_CRYPTO,
                        selected:
                          gateway.technicalMethodKind === METHOD_KIND.MK_CRYPTO,
                      },
                    ]}
                    onChange={(event) => {
                      handleChange({
                        target: {
                          value: event[0]?.value ?? null,
                          name: 'technicalMethodKind',
                          type: '',
                        },
                      })
                    }}
                  />
                  <CMultiSelect
                    key="technicalCountryCodeA3"
                    id="technicalCountryCodeA3"
                    label="Technical country"
                    className="mb-3"
                    multiple={false}
                    virtualScroller
                    options={[
                      ...transformCountriesToOptions(countriesList).map(
                        (country) => {
                          if (gateway.technicalCountryCodeA3 == country.value) {
                            return { ...country, selected: true }
                          } else {
                            return { ...country, selected: false }
                          }
                        },
                      ),
                    ]}
                    onChange={(event) => {
                      handleChange({
                        target: {
                          value: event[0]?.value ?? null,
                          name: 'technicalCountryCodeA3',
                          type: '',
                        },
                      })
                    }}
                  />
                  <p>
                    depositVerificationRequired -{' '}
                    <CFormCheck
                      name="depositVerificationRequired"
                      id="depositVerificationRequired"
                      checked={gateway.depositVerificationRequired}
                      onChange={handleChange}
                    />
                  </p>
                  <p>
                    Archived -{' '}
                    <CFormCheck
                      name="isDisable"
                      checked={gateway.isDisable}
                      onChange={handleChange}
                    />
                  </p>
                  <CButton
                    color="success"
                    className="ms-2"
                    disabled={loading}
                    onClick={() => {
                      submitEditGateway(gateway)
                    }}
                  >
                    Update gateway
                  </CButton>
                </CCol>
              </CRow>
              <Divider />
              <CRow className="mb-3 align-items-center bg-light pb-3 pt-3">
                <CCol>
                  <strong>Operation:</strong>
                  <CForm>
                    <CRow className="mb-3 align-items-center">
                      {gateway.gatewayOperations?.map((element, index) => {
                        return (
                          <CCol key={index}>
                            <Card
                              title={element.operationType}
                              bordered={false}
                              extra={
                                <CButton
                                  onClick={() => setDeleteOperation(element)}
                                  color="danger"
                                >
                                  <CloseCircleOutlined />
                                </CButton>
                              }
                            >
                              <CFormSelect
                                key={
                                  gateway.gatewayId +
                                  element.operationType +
                                  'Access'
                                }
                                id={
                                  gateway.gatewayId +
                                  element.operationType +
                                  'Access'
                                }
                                label="Operation type"
                                value={element.operationType}
                                onChange={(event) =>
                                  handleOperationChange(
                                    index,
                                    'operationType',
                                    event.target.value,
                                  )
                                }
                              >
                                <option>Select type</option>
                                <option value="deposit">Deposit</option>
                                <option value="withdrawal">Withdrawal</option>
                              </CFormSelect>
                              <CFormSelect
                                key={gateway.gatewayId + element.activity}
                                id={gateway.gatewayId + element.activity}
                                label="Activity"
                                value={element.activity}
                                onChange={(event) =>
                                  handleOperationChange(
                                    index,
                                    'activity',
                                    event.target.value,
                                  )
                                }
                              >
                                <option>Select type</option>
                                <option value="enabled">Enabled</option>
                                <option value="disabled">Disabled</option>
                                <option value="maintenance">Maintenance</option>
                              </CFormSelect>
                              {element.activity === 'maintenance' && (
                                <>
                                  <CFormInput
                                    key={element.gatewayId + 'maintenance'}
                                    id={element.gatewayId + 'maintenance'}
                                    value={element.maintenanceMessage}
                                    label="Maintenance message"
                                    onChange={(event) =>
                                      handleOperationChange(
                                        index,
                                        'maintenanceMessage',
                                        event.target.value,
                                      )
                                    }
                                  />
                                  <div>
                                    <label>Maintenance start</label>
                                    <DatePicker
                                      key={
                                        element.gatewayId + 'maintenanceStart'
                                      }
                                      showTime
                                      format="YYYY-MM-DD HH:mm:ss"
                                      value={
                                        element.maintenanceStart
                                          ? dayjs.unix(
                                              Number(element.maintenanceStart),
                                            )
                                          : null
                                      }
                                      onChange={(date) => {
                                        handleOperationChange(
                                          index,
                                          'maintenanceStart',
                                          date ? String(date.unix()) : '',
                                        )
                                      }}
                                      style={{ width: '100%' }}
                                    />
                                  </div>
                                  <div>
                                    <label>Maintenance end</label>
                                    <DatePicker
                                      key={element.gatewayId + 'maintenanceEnd'}
                                      showTime
                                      format="YYYY-MM-DD HH:mm:ss"
                                      value={
                                        element.maintenanceEnd
                                          ? dayjs.unix(
                                              Number(element.maintenanceEnd),
                                            )
                                          : null
                                      }
                                      onChange={(date) => {
                                        handleOperationChange(
                                          index,
                                          'maintenanceEnd',
                                          date ? String(date.unix()) : '',
                                        )
                                      }}
                                      style={{ width: '100%' }}
                                    />
                                  </div>
                                </>
                              )}
                              <CFormInput
                                key={element.gatewayId + 'time'}
                                id={element.gatewayId + 'time'}
                                value={element.processingTime}
                                label="Processing time"
                                onChange={(event) =>
                                  handleOperationChange(
                                    index,
                                    'processingTime',
                                    event.target.value,
                                  )
                                }
                              />
                              <CFormInput
                                key={element.gatewayId + 'limits'}
                                id={element.gatewayId + 'limits'}
                                value={element.limits}
                                label="Limits"
                                onChange={(event) =>
                                  handleOperationChange(
                                    index,
                                    'limits',
                                    event.target.value,
                                  )
                                }
                              />
                              <CFormInput
                                key={element.gatewayId + 'description'}
                                id={element.gatewayId + 'description'}
                                value={element.description}
                                label="Description"
                                onChange={(event) =>
                                  handleOperationChange(
                                    index,
                                    'description',
                                    event.target.value,
                                  )
                                }
                              />
                              <CFormInput
                                key={element.gatewayId + 'warningMessage'}
                                id={element.gatewayId + 'warningMessage'}
                                value={element.warningMessage}
                                label="Warning message"
                                onChange={(event) =>
                                  handleOperationChange(
                                    index,
                                    'warningMessage',
                                    event.target.value,
                                  )
                                }
                              />
                              <CFormInput
                                key={element.gatewayId + 'novaCommissionString'}
                                id={element.gatewayId + 'novaCommissionString'}
                                value={element.novaCommissionString}
                                label="Nova Commission String"
                                onChange={(event) =>
                                  handleOperationChange(
                                    index,
                                    'novaCommissionString',
                                    event.target.value,
                                  )
                                }
                              />
                              <CFormInput
                                key={element.gatewayId + 'hwCommissionString'}
                                id={element.gatewayId + 'hwCommissionString'}
                                value={element.hwCommissionString}
                                label="HW Commission String"
                                onChange={(event) =>
                                  handleOperationChange(
                                    index,
                                    'hwCommissionString',
                                    event.target.value,
                                  )
                                }
                              />
                              <Divider />
                              <CRow className="mb-3 align-items-center bg-light pb-3 pt-3">
                                <CCol>
                                  <strong>Operation limits:</strong>
                                  <CForm>
                                    <CRow className="mb-3 align-items-center">
                                      {gateway.gatewayOperations[
                                        index
                                      ]?.gatewayOperationLimits?.map(
                                        (limitElement, limitIndex) => {
                                          return (
                                            <CCol key={limitIndex}>
                                              <Card
                                                title={`${limitElement.operationType} ${limitElement.currency}`}
                                                bordered={false}
                                                extra={
                                                  <CButton
                                                    disabled={loading}
                                                    onClick={() =>
                                                      setDeleteOperationLimit(
                                                        limitElement,
                                                      )
                                                    }
                                                    color="danger"
                                                  >
                                                    <CloseCircleOutlined />
                                                  </CButton>
                                                }
                                              >
                                                <CFormInput
                                                  key={limitIndex + 'currency'}
                                                  id={limitIndex + 'currency'}
                                                  value={limitElement.currency}
                                                  label="Currency"
                                                  onChange={(event) =>
                                                    handleOperationLimitChange(
                                                      index,
                                                      limitIndex,
                                                      'currency',
                                                      event.target.value,
                                                    )
                                                  }
                                                />
                                                <CFormInput
                                                  key={limitIndex + 'minAmount'}
                                                  id={limitIndex + 'minAmount'}
                                                  value={limitElement.minAmount}
                                                  label="Min Amount"
                                                  onChange={(event) =>
                                                    handleOperationLimitChange(
                                                      index,
                                                      limitIndex,
                                                      'minAmount',
                                                      event.target.value,
                                                    )
                                                  }
                                                />
                                                <CFormInput
                                                  key={limitIndex + 'maxAmount'}
                                                  id={limitIndex + 'maxAmount'}
                                                  value={limitElement.maxAmount}
                                                  label="Max Amount"
                                                  onChange={(event) =>
                                                    handleOperationLimitChange(
                                                      index,
                                                      limitIndex,
                                                      'maxAmount',
                                                      event.target.value,
                                                    )
                                                  }
                                                />
                                              </Card>
                                            </CCol>
                                          )
                                        },
                                      )}
                                      <CCol>
                                        <Card
                                          bordered={false}
                                          style={{ width: 108 }}
                                          className="d-flex align-items-center justify-content-center"
                                          onClick={() => {
                                            if (
                                              gateway.gatewayOperations[index]
                                                .gatewayOperationLimits ==
                                              undefined
                                            ) {
                                              gateway.gatewayOperations[
                                                index
                                              ].gatewayOperationLimits = [
                                                {
                                                  gatewayId: gateway.gatewayId,
                                                  operationType:
                                                    gateway.gatewayOperations[
                                                      index
                                                    ].operationType,
                                                  currency: '',
                                                  maxAmount: '',
                                                  minAmount: '',
                                                },
                                              ]
                                            } else {
                                              gateway.gatewayOperations[
                                                index
                                              ].gatewayOperationLimits = [
                                                ...gateway.gatewayOperations[
                                                  index
                                                ].gatewayOperationLimits,
                                                {
                                                  gatewayId: gateway.gatewayId,
                                                  operationType:
                                                    gateway.gatewayOperations[
                                                      index
                                                    ].operationType,
                                                  currency: '',
                                                  maxAmount: '',
                                                  minAmount: '',
                                                },
                                              ]
                                            }

                                            setGateway({ ...gateway })
                                          }}
                                        >
                                          <h1>
                                            <PlusSquareOutlined
                                              className={'summary'}
                                            />
                                          </h1>
                                        </Card>
                                      </CCol>
                                    </CRow>
                                  </CForm>
                                  <CButton
                                    color="success"
                                    className="ms-2"
                                    disabled={loading}
                                    onClick={() => {
                                      submitSaveQueue(
                                        gateway.gatewayOperations[index]
                                          .gatewayOperationLimits,
                                        submitSaveOperationLimit,
                                      )
                                    }}
                                  >
                                    Update operation limits
                                  </CButton>
                                </CCol>
                              </CRow>
                            </Card>
                          </CCol>
                        )
                      })}
                      {gateway.gatewayOperations.length < 2 && (
                        <CCol>
                          <Card
                            bordered={false}
                            style={{ width: 108 }}
                            className="d-flex align-items-center justify-content-center"
                            onClick={() => {
                              setGateway({
                                ...gateway,
                                gatewayOperations: [
                                  ...gateway.gatewayOperations,
                                  {
                                    gatewayId: gateway.gatewayId,
                                    operationType: '',
                                    processingTime: '',
                                    limits: '',
                                    activity: '',
                                    maintenanceMessage: '',
                                    maintenanceStart: '',
                                    maintenanceEnd: '',
                                    description: '',
                                    warningMessage: '',
                                    currencies: '',
                                    novaCommissionString: '',
                                    hwCommissionString: '',
                                    gatewayOperationLimits: [],
                                  },
                                ],
                              })
                            }}
                          >
                            <h1>
                              <PlusSquareOutlined className={'summary'} />
                            </h1>
                          </Card>
                        </CCol>
                      )}
                    </CRow>
                  </CForm>
                  <CButton
                    color="success"
                    className="ms-2"
                    disabled={loading}
                    onClick={() => {
                      submitSaveQueue(
                        gateway.gatewayOperations,
                        submitSaveOperation,
                      )
                    }}
                  >
                    Update operations
                  </CButton>
                </CCol>
              </CRow>
              <Divider />
              <CRow className="mb-3 justify-content-start bg-light pb-3 pt-3">
                <CCol>
                  <CommissionFormComponent
                    gateway={gateway}
                    loading={loading}
                    handleCommissionChange={handleCommissionChange}
                    submitSaveQueue={() =>
                      submitSaveQueue(
                        gateway.gatewayCommissions,
                        submitSaveCommission,
                      )
                    }
                  />
                </CCol>
              </CRow>
              <Divider />
              <CRow className="mb-3 justify-content-start bg-light pb-3 pt-3">
                <CCol>
                  <strong>Access:</strong>
                  <CForm>
                    <CRow className="mb-3 align-items-center">
                      {gateway.gatewayAccess.map((element, index) => {
                        return (
                          <CCol>
                            <Card
                              title={element.operationType}
                              bordered={false}
                              extra={
                                <CButton
                                  onClick={() => setDeleteAccess(element)}
                                  disabled={loading}
                                  color="danger"
                                >
                                  <CloseCircleOutlined />
                                </CButton>
                              }
                            >
                              <CFormSelect
                                key={
                                  gateway.gatewayId +
                                  element.operationType +
                                  'Access'
                                }
                                id={
                                  gateway.gatewayId +
                                  element.operationType +
                                  'Access'
                                }
                                label="Operation type"
                                value={element.operationType}
                                onChange={(event) =>
                                  handleAccessChange(
                                    index,
                                    'operationType',
                                    event.target.value,
                                  )
                                }
                                required={true}
                              >
                                <option>Select type</option>
                                <option value="deposit">Deposit</option>
                                <option value="withdrawal">Withdrawal</option>
                              </CFormSelect>
                              <CMultiSelect
                                key={
                                  gateway.gatewayId +
                                  element.operationType +
                                  'country'
                                }
                                id={
                                  gateway.gatewayId +
                                  element.operationType +
                                  'country'
                                }
                                label="Allowed countries"
                                options={[
                                  {
                                    text: 'All',
                                    value: '*',
                                    selected:
                                      // @ts-ignore
                                      element.allowedCountries.includes('*'),
                                  },
                                  ...transformCountriesToOptions(
                                    countriesList,
                                  ).map((country) => {
                                    if (
                                      element.allowedCountries.includes(
                                        // @ts-ignore
                                        country.value,
                                      )
                                    ) {
                                      return { ...country, selected: true }
                                    } else {
                                      return { ...country, selected: false }
                                    }
                                  }),
                                ]}
                                virtualScroller
                                onChange={(event) => {
                                  let allowedCountries: (string | number)[] = []
                                  event.forEach((item) =>
                                    allowedCountries.push(item.value),
                                  )
                                  handleAccessChange(
                                    index,
                                    'allowedCountries',
                                    allowedCountries,
                                  )
                                }}
                              ></CMultiSelect>
                              <CFormInput
                                key={index + 'minAndroidAppVersion'}
                                id={index + 'minAndroidAppVersion'}
                                value={element.minAndroidAppVersion}
                                label="minAndroidAppVersion"
                                onChange={(event) =>
                                  handleAccessChange(
                                    index,
                                    'minAndroidAppVersion',
                                    event.target.value,
                                  )
                                }
                              />
                              <CFormInput
                                key={index + 'maxAndroidAppVersion'}
                                id={index + 'maxAndroidAppVersion'}
                                value={element.maxAndroidAppVersion}
                                label="maxAndroidAppVersion"
                                onChange={(event) =>
                                  handleAccessChange(
                                    index,
                                    'maxAndroidAppVersion',
                                    event.target.value,
                                  )
                                }
                              />
                              <CFormInput
                                key={index + 'minIOSAppVersion'}
                                id={index + 'minIOSAppVersion'}
                                value={element.minIOSAppVersion}
                                label="minIOSAppVersion"
                                onChange={(event) =>
                                  handleAccessChange(
                                    index,
                                    'minIOSAppVersion',
                                    event.target.value,
                                  )
                                }
                              />
                              <CFormInput
                                key={index + 'maxIOSAppVersion'}
                                id={index + 'maxIOSAppVersion'}
                                value={element.maxIOSAppVersion}
                                label="maxIOSAppVersion"
                                onChange={(event) =>
                                  handleAccessChange(
                                    index,
                                    'maxIOSAppVersion',
                                    event.target.value,
                                  )
                                }
                              />
                              <Divider />
                              <CFormCheck
                                name={index + 'allowedForWeb'}
                                id={index + 'allowedForWeb'}
                                checked={element.allowedForWeb}
                                label="Allowed for Web"
                                onChange={(event) =>
                                  handleAccessChange(
                                    index,
                                    'allowedForWeb',
                                    event.target.type === 'checkbox'
                                      ? event.target.checked
                                      : event.target.value,
                                  )
                                }
                              />
                              <CFormCheck
                                name={index + 'allowedForAndroid'}
                                id={index + 'allowedForAndroid'}
                                checked={element.allowedForAndroid}
                                label="Allowed for Android"
                                onChange={(event) =>
                                  handleAccessChange(
                                    index,
                                    'allowedForAndroid',
                                    event.target.type === 'checkbox'
                                      ? event.target.checked
                                      : event.target.value,
                                  )
                                }
                              />
                              <CFormCheck
                                name={index + 'allowedForIOS'}
                                id={index + 'allowedForIOS'}
                                checked={element.allowedForIOS}
                                label="Allowed for IOS"
                                onChange={(event) =>
                                  handleAccessChange(
                                    index,
                                    'allowedForIOS',
                                    event.target.type === 'checkbox'
                                      ? event.target.checked
                                      : event.target.value,
                                  )
                                }
                              />
                              <CFormInput
                                key={index + 'minAndroidNovaAppVersion'}
                                id={index + 'minAndroidNovaAppVersion'}
                                value={element.minAndroidNovaAppVersion}
                                label="minAndroidNovaAppVersion"
                                onChange={(event) =>
                                  handleAccessChange(
                                    index,
                                    'minAndroidNovaAppVersion',
                                    event.target.value,
                                  )
                                }
                              />
                              <CFormInput
                                key={index + 'maxAndroidNovaAppVersion'}
                                id={index + 'maxAndroidNovaAppVersion'}
                                value={element.maxAndroidNovaAppVersion}
                                label="maxAndroidNovaAppVersion"
                                onChange={(event) =>
                                  handleAccessChange(
                                    index,
                                    'maxAndroidNovaAppVersion',
                                    event.target.value,
                                  )
                                }
                              />
                              <CFormInput
                                key={index + 'minIOSNovaAppVersion'}
                                id={index + 'minIOSNovaAppVersion'}
                                value={element.minIOSNovaAppVersion}
                                label="minIOSNovaAppVersion"
                                onChange={(event) =>
                                  handleAccessChange(
                                    index,
                                    'minIOSNovaAppVersion',
                                    event.target.value,
                                  )
                                }
                              />
                              <CFormInput
                                key={index + 'maxIOSNovaAppVersion'}
                                id={index + 'maxIOSNovaAppVersion'}
                                value={element.maxIOSNovaAppVersion}
                                label="maxIOSNovaAppVersion"
                                onChange={(event) =>
                                  handleAccessChange(
                                    index,
                                    'maxIOSNovaAppVersion',
                                    event.target.value,
                                  )
                                }
                              />
                              <Divider />
                              <CFormCheck
                                name={index + 'allowedForNovaWeb'}
                                id={index + 'allowedForNovaWeb'}
                                checked={element.allowedForNovaWeb}
                                label="Allowed for NOVA Web"
                                onChange={(event) =>
                                  handleAccessChange(
                                    index,
                                    'allowedForNovaWeb',
                                    event.target.type === 'checkbox'
                                      ? event.target.checked
                                      : event.target.value,
                                  )
                                }
                              />
                              <CFormCheck
                                name={index + 'allowedForNovaAndroid'}
                                id={index + 'allowedForNovaAndroid'}
                                checked={element.allowedForNovaAndroid}
                                label="Allowed for NOVA Android"
                                onChange={(event) =>
                                  handleAccessChange(
                                    index,
                                    'allowedForNovaAndroid',
                                    event.target.type === 'checkbox'
                                      ? event.target.checked
                                      : event.target.value,
                                  )
                                }
                              />
                              <CFormCheck
                                name={index + 'allowedForNovaIOS'}
                                id={index + 'allowedForNovaIOS'}
                                checked={element.allowedForNovaIOS}
                                label="Allowed for NOVA IOS"
                                onChange={(event) =>
                                  handleAccessChange(
                                    index,
                                    'allowedForNovaIOS',
                                    event.target.type === 'checkbox'
                                      ? event.target.checked
                                      : event.target.value,
                                  )
                                }
                              />
                            </Card>
                          </CCol>
                        )
                      })}
                      <br />
                      {gateway.gatewayAccess.length < 2 && (
                        <>
                          <CCol>
                            <Card
                              bordered={false}
                              style={{ width: 108 }}
                              className="d-flex align-items-center justify-content-center"
                              onClick={() => {
                                setGateway({
                                  ...gateway,
                                  gatewayAccess: [
                                    ...gateway.gatewayAccess,
                                    {
                                      gatewayId: gateway.gatewayId,
                                      operationType: '',
                                      minAndroidAppVersion: '',
                                      minIOSAppVersion: '',
                                      maxAndroidAppVersion: '',
                                      maxIOSAppVersion: '',
                                      allowedForWeb: false,
                                      allowedForAndroid: false,
                                      allowedForIOS: false,
                                      minAndroidNovaAppVersion: '',
                                      minIOSNovaAppVersion: '',
                                      maxAndroidNovaAppVersion: '',
                                      maxIOSNovaAppVersion: '',
                                      allowedForNovaWeb: false,
                                      allowedForNovaAndroid: false,
                                      allowedForNovaIOS: false,
                                      allowedCountries: [],
                                    },
                                  ],
                                })
                              }}
                            >
                              <h1>
                                <PlusSquareOutlined className={'summary'} />
                              </h1>
                            </Card>
                          </CCol>
                        </>
                      )}
                    </CRow>
                  </CForm>
                  <CButton
                    color="success"
                    className="ms-2"
                    disabled={loading}
                    onClick={() => {
                      submitSaveQueue(gateway.gatewayAccess, submitSaveAccess)
                    }}
                  >
                    Update access
                  </CButton>
                </CCol>
              </CRow>
              <Divider />
              <CRow className="mb-3 align-items-center bg-light pb-3 pt-3">
                <CCol>
                  <strong>Weight:</strong>
                  <CForm>
                    <CRow className="mb-3 d-flex align-items-center justify-content-center bg-light pb-3 pt-3">
                      {gateway.gatewayWeight.map((element, index) => {
                        return (
                          <>
                            <CCol>
                              <Card
                                size="small"
                                title={element.countryCodeA3}
                                bordered={false}
                                extra={
                                  <CButton
                                    onClick={() => setDeleteWeight(element)}
                                    disabled={loading}
                                    color="danger"
                                  >
                                    <CloseCircleOutlined />
                                  </CButton>
                                }
                                style={{ width: 300 }}
                                className="m-3"
                              >
                                <CFormSelect
                                  key={
                                    gateway.gatewayId +
                                    element.operationType +
                                    'Weight'
                                  }
                                  id={
                                    gateway.gatewayId +
                                    element.operationType +
                                    'Weight'
                                  }
                                  label="Operation type"
                                  value={element.operationType}
                                  onChange={(event) =>
                                    handleWeightChange(
                                      index,
                                      'operationType',
                                      event.target.value,
                                    )
                                  }
                                >
                                  <option>Select type</option>
                                  <option value="deposit">Deposit</option>
                                  <option value="withdrawal">Withdrawal</option>
                                </CFormSelect>
                                <CMultiSelect
                                  key={
                                    gateway.gatewayId +
                                    element.countryCodeA3 +
                                    'country'
                                  }
                                  id={
                                    gateway.gatewayId +
                                    element.countryCodeA3 +
                                    'country'
                                  }
                                  label="Country"
                                  multiple={false}
                                  virtualScroller
                                  options={[
                                    {
                                      text: 'All',
                                      value: '*',
                                      selected:
                                        // @ts-ignore
                                        element.countryCodeA3 == '*',
                                    },
                                    ...transformCountriesToOptions(
                                      countriesList,
                                    ).map((country) => {
                                      if (
                                        element.countryCodeA3 == country.value
                                      ) {
                                        return { ...country, selected: true }
                                      } else {
                                        return { ...country, selected: false }
                                      }
                                    }),
                                  ]}
                                  onChange={(event) => {
                                    let country: (string | number)[] = []
                                    event.forEach((item) =>
                                      country.push(item.value),
                                    )
                                    handleWeightChange(
                                      index,
                                      'countryCodeA3',
                                      country.pop(),
                                    )
                                  }}
                                />
                                <CFormInput
                                  key={element.gatewayId + 'weight'}
                                  id={element.gatewayId + 'weight'}
                                  value={element.weight}
                                  label="weight"
                                  onChange={(event) =>
                                    handleWeightChange(
                                      index,
                                      'weight',
                                      event.target.value,
                                    )
                                  }
                                />
                              </Card>
                            </CCol>
                          </>
                        )
                      })}
                      <>
                        <CCol>
                          <Card
                            bordered={false}
                            style={{ width: 108 }}
                            className="d-flex align-items-center justify-content-center"
                            onClick={() => {
                              setGateway({
                                ...gateway,
                                gatewayWeight: [
                                  ...gateway.gatewayWeight,
                                  {
                                    gatewayId: gateway.gatewayId,
                                    weight: 1,
                                    operationType: '',
                                    countryCodeA3: '',
                                  },
                                ],
                              })
                            }}
                          >
                            <h1>
                              <PlusSquareOutlined className={'summary'} />
                            </h1>
                          </Card>
                        </CCol>
                      </>
                    </CRow>
                  </CForm>
                  <CButton
                    color="success"
                    className="ms-2"
                    disabled={loading}
                    onClick={() => {
                      submitSaveQueue(gateway.gatewayWeight, submitSaveWeight)
                    }}
                  >
                    Update weight
                  </CButton>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
      <Guard permission={GUARD_RULES.EDIT_PAYMENT_GATEWAY_NOTIFICATION}>
        <CCard className="mt-4 border-info">
          <CCardHeader className="text-info">
            <strong>Gateway Notification</strong>
          </CCardHeader>
          <CCardBody>
            <div className="d-flex justify-content-between align-items-center gap-5">
              {!gateway.gatewayClientNotification?.isActive && (
                <>
                  <span>
                    No notification is set for the current gateway{' '}
                    <strong>{gateway.internalName}</strong>
                  </span>

                  <CButton
                    color="danger"
                    onClick={() => setGatewayAddNotice(gateway)}
                  >
                    Set Notification
                  </CButton>
                </>
              )}
              {gateway.gatewayClientNotification?.isActive && (
                <>
                  {' '}
                  <div>
                    <div className="fs-6">
                      The current gateway{' '}
                      <strong className="text-info">
                        {gateway.internalName}
                      </strong>{' '}
                      has the following notification:{' '}
                    </div>
                    <div className="text-secondary fst-italic">
                      {getNoticeText(gateway.gatewayClientNotification.message)}
                    </div>
                  </div>
                  <CButton
                    color="info"
                    onClick={() => setGatewayRemoveNotice(gateway)}
                    className="flex-shrink-0"
                  >
                    Remove Notification
                  </CButton>
                </>
              )}
            </div>
          </CCardBody>
        </CCard>
      </Guard>
      <Guard permission="edit_payments">
        <CCard className="mt-4 border-danger">
          <CCardHeader className="text-danger">
            <strong>Danger zone</strong>
          </CCardHeader>
          <CCardBody>
            <Popconfirm
              title="Delete this gateway?"
              description="This action cannot be undone."
              okText="Delete"
              cancelText="Cancel"
              okButtonProps={{ danger: true }}
              onConfirm={() => {
                deleteGatewayEvent(Number(gateway.gatewayId))
                toPath(path.billing.gateway.entry())
              }}
            >
              <Button danger icon={<DeleteOutlined />}>
                Delete gateway
              </Button>
            </Popconfirm>
          </CCardBody>
        </CCard>
      </Guard>
      {gatewayAddNotice && (
        <AddNoticeModal
          gateway={gatewayAddNotice}
          onClose={() => setGatewayAddNotice(null)}
        />
      )}
      {gatewayRemoveNotice && (
        <RemoveNoticeModal
          gateway={gatewayRemoveNotice}
          onClose={() => setGatewayRemoveNotice(null)}
        />
      )}
    </div>
  )
}
